import { posthogClient } from './utils/posthogEarlyInit';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';
import './index.css';
import './styles/no-yellow.css';

// Import testing utilities (makes functions available globally)
import './utils/testOnboarding';
import './utils/featureFlags';

import {
  initStaleChunkRecoverySession,
  isLikelyStaleChunkLoadFailure,
  maybeReloadOnceForStaleChunk,
} from './utils/staleChunkRecovery';
initStaleChunkRecoverySession();

if (!import.meta.env.DEV) {
  window.addEventListener('unhandledrejection', (event) => {
    if (isLikelyStaleChunkLoadFailure(event.reason)) {
      event.preventDefault();
      maybeReloadOnceForStaleChunk(event.reason);
    }
  });
}

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// PostHog is initialized in posthogEarlyInit, which is the first import, so
// startup errors are captured before React mounts. The provider receives that
// client. Staging and dev use the same options as production.
// PostHog React Router guide: PostHogProvider wraps BrowserRouter (not the reverse).
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {posthogClient ? (
        <PostHogProvider client={posthogClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PostHogProvider>
      ) : (
        <BrowserRouter>
          <App />
        </BrowserRouter>
      )}
    </QueryClientProvider>
  </React.StrictMode>
); 